/* istanbul ignore file */

import * as React from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { ThemeProvider, CssBaseline, Box } from '@mui/material';
import {
    AvatarUrlProvider,
    BoxSkeleton,
    ModalProvider,
    SkeletonLoader,
} from '@europrocurement/flexy-components';
import { UseKeycloakService } from '@europrocurement/l2d-keycloak';
import { setXIdSociete, useSociete } from '@europrocurement/l2d-domain';
import Router from './router/router';
import L2DTheme from './Theme';
import { useAppDispatch } from './redux/types';

const router = createBrowserRouter(Router);

const App = function () {
    const theme = L2DTheme();
    const kc = UseKeycloakService();
    const xIdSociete = useSociete();

    const isApplicationReady = () => kc.isInitialized();

    const dispatch = useAppDispatch();

    React.useEffect(() => {
        if (xIdSociete !== 12) {
            dispatch(setXIdSociete(12));
        }
    });

    return (
        <AvatarUrlProvider>
            <ModalProvider>
                <ThemeProvider theme={theme}>
                    <SkeletonLoader
                        isLoading={!isApplicationReady()}
                        skeleton={
                            <Box
                                sx={{
                                    width: '100vw',
                                    height: '100vh',
                                    display: 'flex',
                                    flexDirection: 'row',
                                    alignItems: 'center',
                                    justifyContent: 'space-evenly',
                                }}
                            >
                                <BoxSkeleton sx={{ width: '13vw', height: '97vh' }} />
                                <Box
                                    sx={{
                                        width: '84vw',
                                        height: '100%',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        justifyContent: 'space-evenly',
                                    }}
                                >
                                    <BoxSkeleton sx={{ width: '84vw', height: '7vh' }} />
                                    <BoxSkeleton sx={{ width: '84vw', height: '89vh' }} />
                                </Box>
                            </Box>
                        }
                    >
                        {isApplicationReady() ? <RouterProvider router={router} /> : null}
                    </SkeletonLoader>
                    <CssBaseline />
                </ThemeProvider>
            </ModalProvider>
        </AvatarUrlProvider>
    );
};

export default App;
